import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import customerRegistration from 'src/repositories/customerRegistration';

const apiKey = '/customers';

const useCustomers = () => {
  const { data, ...rest } = useQuery<
    AxiosResponse<Response.CustomerType>,
    AxiosError<any>
  >([apiKey], customerRegistration.getCustomerType, {
    retry: 0,
    onError(err) {
      console.log(err.response);
    },
  });
  return {
    data: data?.data?.item,
    ...rest,
  };
};

export default useCustomers;
